import { useCallback } from 'react'

const useHandleViewCorrectPart = param => {
  const {
    product,
    modifiers,
  } = param

  return useCallback(
    () => {
      let queryParameter = `&q=${encodeURIComponent(product.part.name)}`

      if (modifiers.vehicle && modifiers.vehicle.details) {
        Object.keys(modifiers.vehicle.details).forEach(key => {
          const value = modifiers.vehicle.details[`${key}`]
          if (key === 'engine' && value !== '') {
            const [cylinder, liter] = value.split(' Cyl ')
            queryParameter += `&vehicle[cylinders]=${encodeURIComponent(cylinder)}`
            queryParameter += `&vehicle[liter]=${encodeURIComponent(liter.replace('L', ''))}`
            return
          }

          queryParameter += `&vehicle[${key}]=${encodeURIComponent(value)}`
        })
      }

      window.location.href = `/search?${queryParameter}`
    },
    [product, modifiers],
  )
}

export default useHandleViewCorrectPart
